import React, { useContext } from 'react';
import styled from 'styled-components';
import { LikutModals } from '../../../../../../modules/Context/CefiNum';
import LikutGoodsListView from './LikutGoodsListView';

interface Props {
    azmanotListDefault: any[];
    defaultPackageList: any[];
    entryLine: any;
    isWeightCalculation: boolean;
    isAddIdToDesc: boolean;
    isOffice: boolean;
    recID: number | null;
    setRecID: (id: number) => void;
    setGoodsCode: (code: string) => void;
    editOrderRow: (problem: number, reson: number) => void;
    selectGoodForLikut: (index: number) => void;
    handleSelectOrderLine: (recID: number) => void;
    handleOpenProductLocationModal: (product: any) => void;
    closeFunc?: (flag?: boolean) => void;
}

const ModalAzmanaRows: React.FC<Props> = ({
    azmanotListDefault,
    defaultPackageList,
    entryLine,
    isWeightCalculation,
    isAddIdToDesc,
    isOffice,
    recID,
    setRecID,
    setGoodsCode,
    editOrderRow,
    selectGoodForLikut,
    handleSelectOrderLine,
    handleOpenProductLocationModal,
}) => {
    const [resonState] = useContext<any>(LikutModals);
    // Manual flow has no entry line — without a family to filter by, show every
    // order row. `== null` keeps a scanned ProductFamilyId of 0 filtering as before.
    const filtered = entryLine?.ProductFamilyId == null
        ? azmanotListDefault
        : azmanotListDefault.filter(
            (item) => item.ProductFamilyId === entryLine.ProductFamilyId
        );

    return (
        <ListCard>
            <LikutGoodsListView
                azmanotList={filtered}
                selecteble
                defaultPackageList={defaultPackageList}
                isWeightCalculation={isWeightCalculation}
                isAddIdToDesc={isAddIdToDesc}
                isOffice={isOffice}
                isAllowMultipleSave={false}
                recID={recID}
                setRecID={setRecID}
                setGoodsCode={setGoodsCode}
                editOrderRow={editOrderRow}
                selectGoodForLikut={selectGoodForLikut}
                handleSelectOrderLine={handleSelectOrderLine}
                handleOpenProductLocationModal={handleOpenProductLocationModal}
                setDefaultPacks={resonState?.props?.setDefProd}
                deleteFromPallet={() => {}}
            />
        </ListCard>
    );
};

export default ModalAzmanaRows;

const ListCard = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    border: 1px solid ${({ theme }) => theme.colors.line};
    border-radius: 1rem;
    background: ${({ theme }) => theme.colors.surface};
    overflow: hidden;
`;
